import React from 'react'
import { Row as AntRow } from 'antd'

const Row = (props) => <AntRow {...props}/>

Row.AntRow = AntRow
export default Row
